<template>
  <section v-if="!currentViewKey">
    <Loading />
  </section>
  <section v-else-if="current && current.name" class="prompts" :class="{ settings: settingsShown }">
    <ContentChain ref="chainContent" :key="currentViewKey" :item="current" />
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Loading from '@/components/common/Loading';

import ContentChain from './ContentChain.vue';
export default {
  components: {
    Loading,
    ContentChain
  },
  props: {},
  data() {
    return {
      settingsShown: false,
      itemId: this.$route.params.id ?? this.$route.query['id']
    };
  },
  computed: {
    ...mapState({
      isGetRequestPending: s => s.prompts.isGetRequestPending,
      isUpdateRequestPending: s => s.prompts.isUpdateRequestPending,
      isDraftRequestPending: s => s.prompts.isDraftRequestPending,
      organizationsCollection: s => s.organizations.collection ?? [],
      categoriesCollection: s => s.library.categories ?? [],
      current: s => s.prompts.current,
      currentView: s => s.prompts.currentView,
      currentViewKey: s => s.prompts.currentViewKey
    }),
    organizationsNames() {
      if (!this.current || !this.organizationsCollection) {
        return [];
      }

      const organizations = this.current.organizations
        ? this.current.organizations.map(id => this.organizationsCollection.find(o => o.id === id)?.name ?? id)
        : [];

      if (!organizations.length) {
        return [];
      }

      return organizations;
    },
    categoriesNames() {
      if (!this.current || !this.categoriesCollection) {
        return [];
      }

      const categories = this.current.categories
        ? this.current.categories.map(id => {
            const category = this.categoriesCollection.find(c => c.id === id);
            if (category.parentId) {
              const parent = this.categoriesCollection.find(c => c.id === category.parentId)?.name ?? category.parentId;
              return `${parent} > ${category.name}`;
            }
            return category.name;
          })
        : [];
      if (!categories.length) {
        return [];
      }

      return categories;
    }
  },
  watch: {
    id() {
      this.initialize();
    }
  },
  async mounted() {
    this.initialize();
  },
  async destroyed() {
    await this.$store.dispatch('prompts/clear');
  },
  methods: {
    async readyToLeave() {
      if (!this.$refs.chainContent.hasChanges) {
        return true;
      }

      return await this.$confirm({
        title: 'You have unsaved changes.',
        message: `Are you sure you want to leave page? All changes will be lost.`,
        confirm: 'Leave anyway'
      });
    },
    async initialize() {
      await Promise.all([
        this.$store.dispatch('nlp/getConfigurations'),
        this.$store.dispatch('prompts/load', this.itemId),
        this.$store.dispatch('organizations/getCollection'),
        this.$store.dispatch('library/getCategories')
      ]);
    },
    selectTemplate(id) {
      this.$router.push({ path: `/chains/${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.prompts-wrapper {
  width: 100%;
  height: 100%;
}

.prompts {
  width: 100%;
  margin: 0 0.5rem;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  grid-gap: 0.5rem;
  height: 100%;

  &.settings {
    grid-template-rows: max-content max-content max-content;
  }

  > header {
    background: var(--theme-surface);
    padding: 0.2rem 0.5rem;
    justify-content: space-between;
    align-items: center;
    display: flex;

    .prompt-name-wrapper {
      grid-template-rows: auto auto;
      padding: 7px;
      align-items: flex-start;

      .prompt-name {
        text-transform: uppercase;
        font-weight: 600;
        color: var(--theme-on-background-dark);
        padding: 0 5px;
        font-size: 1rem;
        cursor: pointer;
      }

      .button {
        padding: 0;
      }
    }

    .prompt-organization {
      display: flex;
      flex-wrap: wrap;
      padding-left: 25px;

      .organization {
        display: flex;
        align-items: center;
        background-color: var(--theme-on-surface);
        color: black;
        margin-top: 2px;
        padding: 2px;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 0.65rem;
        margin-right: 5px;
        margin-bottom: 2px;
        border-radius: 2px;
        font-weight: 600;
        letter-spacing: 0.02rem;
        user-select: none;
        cursor: auto;
        &.category {
          background-color: #5d4ce8;
        }

        &.public {
          background-color: var(--theme-primary);
          color: var(--theme-on-primary);
        }
      }
    }
  }
}
</style>
